import { useMemo } from "react"

import { useSelector } from "react-redux"

import { ProgramCardsRow } from "../../../components/ReceiptProgramSelector/ProgramCardsRow"
import { CE_PROGRAM_META } from "../../constants/programs"
import { selectPrograms, selectStateFetching } from "../../redux/compelling-evidence.slice"

export const ProgramCards = ({ selectedProgram, onSelect }) => {
  const programs = useSelector(selectPrograms)
  const loading = useSelector(selectStateFetching)

  const cards = useMemo(
    () =>
      programs.map((p) => {
        const id = p.program.toLowerCase()
        const meta = CE_PROGRAM_META[id]

        return {
          id,
          name: meta?.name,
          iconType: meta?.iconType,
          value: p.case_count,
          status: id === "all" ? null : p.status
        }
      }),
    [programs]
  )

  return (
    <ProgramCardsRow
      cards={cards}
      loading={loading}
      selectedProgram={selectedProgram}
      onSelect={onSelect}
    />
  )
}
